import { useState, useEffect } from 'react';
import { billingApi } from './api';

const CACHE_KEY = 'apo_plan_cache_v1';

function readCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    // Expire after 24h to keep fresh-ish but avoid blink on each navigation
    if (Date.now() - (parsed?._t || 0) > 24 * 60 * 60 * 1000) return null;
    return parsed.data || null;
  } catch (e) {
    return null;
  }
}

function writeCache(data) {
  try { localStorage.setItem(CACHE_KEY, JSON.stringify({ data, _t: Date.now() })); } catch (e) {}
}

export function usePlan() {
  // Hydrate from localStorage so navigations don't flash free→premium.
  const cached = typeof window !== 'undefined' ? readCache() : null;
  const [plan, setPlan] = useState(cached);
  // Only show "loading" if we have NO cached plan yet (first install).
  const [loading, setLoading] = useState(!cached);

  useEffect(() => {
    billingApi.getPlan()
      .then((res) => { setPlan(res.data); writeCache(res.data); })
      .catch(() => {
        if (!cached) setPlan({ plan: 'free', plan_info: { name: 'Free', max_option_sets: 5, conditional_logic: false } });
      })
      .finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isPremium = plan?.plan === 'premium';
  const canUseConditionalLogic = isPremium;
  const optionSetsRemaining = plan?.option_sets_remaining ?? 5;
  const optionSetsCount = plan?.option_sets_count ?? 0;
  const maxOptionSets = plan?.plan_info?.max_option_sets ?? 5;

  return { plan, isPremium, canUseConditionalLogic, optionSetsRemaining, optionSetsCount, maxOptionSets, loading };
}
